import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Descricao from "@/components/site/Descricao";
import About from "@/components/site/About";
import Servicos from "@/components/site/Servicos";
import Amenities from "@/components/site/Amenities";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Booking from "@/components/site/Booking";
import LocationContact from "@/components/site/LocationContact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Descricao />
        <About />
        <Servicos />
        <Amenities />
        <Gallery />
        <Testimonials />
        <Booking />
        <LocationContact />
      </main>
      <Footer />
    </div>
  );
}
